import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { IGX_DIALOG_DIRECTIVES, IgxDialogComponent, IgxDialogModule } from '@infragistics/igniteui-angular/dialog';
import { OverlaySettings } from '@infragistics/igniteui-angular/core';
import { IgxIconComponent, IgxIconModule } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleModule } from '@infragistics/igniteui-angular/directives';
import { IGX_NAVBAR_DIRECTIVES, IgxNavbarModule } from '@infragistics/igniteui-angular/navbar';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-alert-dialog-promise',
  templateUrl: './alert-dialog-promise.component.html',
  styleUrls: ['./alert-dialog-promise.component.scss'],
  imports: [
    IgxDialogModule,
    IGX_DIALOG_DIRECTIVES,
    TranslateModule,
    IgxNavbarModule,
    IGX_NAVBAR_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxIconModule,
    IgxIconComponent,
    IgxFocusDirective,
    IgxRippleModule
  ]
})
export class AlertDialogPromiseComponent implements OnInit {
  @ViewChild('alert', {static: true})
  public alertDialog: IgxDialogComponent;
  @Output() evtResuelto = new EventEmitter<boolean>();

  public alertTitulo: string;
  public alertIcon: string;
  public alertMensaje: string;
  public alerttextLeftButton: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  public abrir(mensaje: string, titulo: string, icon: string, textLeftButton: string, overlaySettings: OverlaySettings) {
    this.alertTitulo = titulo;
    this.alertIcon = icon;
    this.alertMensaje = mensaje;
    this.alerttextLeftButton = textLeftButton;
    this.alertDialog.open(overlaySettings);
  }

  public btnOK() {
    this.alertDialog.close();
    this.evtResuelto.emit(true);
  }
}
